import { type ButtonHTMLAttributes, type ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "danger" | "on-dark";
type ButtonSize = "md" | "sm";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  fullWidth?: boolean;
  iconOnly?: boolean;
  children: ReactNode;
}

const sizeClass: Record<ButtonSize, string> = {
  md: "",
  sm: "xpn-btn--sm",
};

export function Button({
  variant = "primary",
  size = "md",
  loading = false,
  fullWidth = false,
  iconOnly = false,
  disabled,
  children,
  className = "",
  ...rest
}: ButtonProps) {
  const classes = [
    "xpn-btn",
    `xpn-btn--${variant}`,
    sizeClass[size],
    fullWidth ? "xpn-btn--full" : "",
    iconOnly ? "xpn-btn--icon" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading ? "Loading..." : children}
    </button>
  );
}
